import moment from 'moment';
import { useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { useHistory } from 'react-router';
import { toast } from 'react-toastify';
import { useAppContext } from '../../../appProvider/contextProvider';
import Amount from '../../../components/Amount/Amout';
import Calendars from '../../../components/Calendars/Calendars';
import { getWooCommerceData, updateWooCommerceData } from '../../../services/woocommerceService';


const WooCommerceAutomation = () => {

    const history = useHistory();

    const {selectedWebsite} = useAppContext();


    const [isFilterOpen , setIsFilterOpen] = useState(false);

    const [wooCommData, setWooCommData] = useState(null);

    
    const [subscribersFilter, setSubscribersFilter] = useState({
        name: 'Last 7 Days',
        startDay: moment().subtract(7, 'days').startOf('day'),
        endDay: moment(),
    });

    useQuery(['fetchWooCommerceStats', {
        webId: selectedWebsite?.id,
        start_date: subscribersFilter.startDay,
        end_date: subscribersFilter.endDay,
    }], () => getWooCommerceData({
        webId: selectedWebsite?.id,
        start_date: subscribersFilter.startDay,
        end_date: subscribersFilter.endDay,
    }),
    {
        enabled: !!selectedWebsite,
        onSuccess: (wooCommData) => {
            setWooCommData(wooCommData);
        }
    }
);


    const getCustomRange = () => {
        return `${moment(subscribersFilter.startDay).format('DD/MM/YYYY')} - ${moment(subscribersFilter.endDay).format('DD/MM/YYYY')}`;
    }


    const navigateTo = (path) => {
        history.push(path);
    } 


    const disableAbandonedCart = useMutation((event) => {
        event.preventDefault();
        const payload = {
            abandoned_cart: {
                is_active: !wooCommData.abandoned_cart?.is_active
              },
        }
        return updateWooCommerceData(selectedWebsite?.id, payload);
    }, {
        onSuccess: (wooCommStats) => {
            if(wooCommStats.errors) {

            }else {
                wooCommData.abandoned_cart.is_active = wooCommStats.abandoned_cart.is_active;
                toast.success(`Abandoned Cart 
                    ${wooCommData.abandoned_cart.is_active ? 'enabled' : 'disabled'}
                    successfully
                    `);
                setWooCommData(wooCommData);
            }
        }
    });
    
    const disableBackInStock = useMutation((event) => {
        event.preventDefault();
        const payload = {
            back_in_stock: {
                is_active: !wooCommData.back_in_stock?.is_active
              },
        }
        return updateWooCommerceData(selectedWebsite?.id, payload);
    }, {
        onSuccess: (wooCommStats) => {
            if(wooCommStats.errors) {

            }else {
                wooCommData.back_in_stock.is_active = wooCommStats.back_in_stock.is_active;
                toast.success(`Back In Stock
                    ${wooCommData.back_in_stock.is_active ? 'enabled' : 'disabled'}
                    successfully
                    `);
                setWooCommData(wooCommData);
            }
        }
    });

    const disablePriceDrop = useMutation((event) => {
        event.preventDefault();
        const payload = {
            price_drop: {
                is_active: !wooCommData.price_drop?.is_active
              },
        }
        return updateWooCommerceData(selectedWebsite?.id, payload);
    }, {
        onSuccess: (wooCommStats) => {
            if(wooCommStats.errors) {

            }else {
                wooCommData.price_drop.is_active = wooCommStats.price_drop.is_active;
                toast.success(`Price Drop 
                    ${wooCommData.price_drop.is_active ? 'enabled' : 'disabled'}
                    successfully
                    `);
                setWooCommData(wooCommData);
            }
        }
    });

    const disableShippingNotification = useMutation((event) => {
        event.preventDefault();
        const payload = {
            shipping_alert: {
                is_active: !wooCommData.shipping_alert?.is_active
              },
        }
        return updateWooCommerceData(selectedWebsite?.id, payload);
    }, {
        onSuccess: (wooCommStats) => {
            if(wooCommStats.errors) {

            }else {
                wooCommData.shipping_alert.is_active = wooCommStats.shipping_alert.is_active;
                toast.success(`Shipping Notification 
                    ${wooCommData.shipping_alert.is_active ? 'enabled' : 'disabled'}
                    successfully
                    `);
                setWooCommData(wooCommData);
            }
        }
    });


    return <>
        <div className="panel full-height">
            <div className="panel-header">
                <div className="row justify-content-between align-items-center">
                    <h3 className="mb-0 col">Woocommerce Automation</h3>
                    <div className="col col-md-3 form-group date-form-group mb-0" >
                            <div className="input-addon input-group-right" onClick={() => setIsFilterOpen(!isFilterOpen)} >
                                <i className="icon icon-calendar"></i>
                                <input
                                    value={subscribersFilter.name !== 'Custom Dates' ? subscribersFilter.name : getCustomRange() }
                                    placeholder="This Week" 
                                    className="form-control"
                                />
                            </div>
                            {
                                isFilterOpen && <Calendars
                                    subscribersFilter={subscribersFilter}
                                    setSubscribersFilter={setSubscribersFilter}
                                    setIsFilterOpen={setIsFilterOpen}
                                />
                            }
                        </div>
                    
                </div>                                
            </div>
            <div className="panel-body scrollable_y">
                <div className="d-flex flex-column">                              
                    <div className="row align-items-center automation-categories">
                        <div className="col-12 col-xl-5 br-right">
                            <div className="media">
                                <div className="media_figure media-rounded">
                                    <i className="icon icon-2x icon-Vector-38"></i>
                                </div>
                                <div className="media-body">
                                    <h6 className="text-dark medium">Abandoned Cart Recovery</h6>
                                    <p className="text-light thin">A Sequence of notifications to remind the subscriber
                                        about the items they forgot in their cart</p>
                                </div>
                            </div>                                            
                        </div>
                        <div className="col-6 col-sm">
                            <label className="thin text-light">Sent</label>
                            <h5 className="text-dark">{wooCommData?.abandoned_cart?.sent || 0}</h5>
                        </div>
                        <div className="col-6 col-sm">
                            <label className="thin text-light">Impressions</label>
                            <h5 className="text-dark">{wooCommData?.abandoned_cart?.delivered || 0}</h5>
                        </div>
                        <div className="col-6 col-sm">
                            <label className="thin text-light">Clicks</label>
                            <h5 className="text-dark">{wooCommData?.abandoned_cart?.opened || 0}</h5>
                        </div>
                        <div className="col-6 col-sm">
                            <label className="thin text-light">Revenue</label>
                            <h5 className="text-dark"><Amount amount={wooCommData?.abandoned_cart?.revenue || 0} /></h5>
                        </div>
                        <div className="col-sm toggle-block">
                            <label className="thin text-light d-none d-lg-block">Actions</label>
                            <label className="toggle-control toggle-control-xs">
                                <input type="checkbox" onChange={disableAbandonedCart.mutate}  checked={wooCommData?.abandoned_cart?.is_active} />
                                <span className="control"></span>
                            </label>
                        </div>
                        <div className="col-12 col-sm align-self-center">
                            <button className="btn btn-primary" onClick={() => navigateTo('/woocommerce-abandoned-cart')} >Setup</button>
                        </div>
                    </div>
                    <div className="row align-items-center automation-categories">
                        <div className="col-12 col-xl-5 br-right">
                            <div className="media">
                                <div className="media_figure media-rounded">
                                    <i className="icon icon-2x icon-Vector-39"></i>
                                </div>
                                <div className="media-body">
                                    <h6 className="text-dark medium">Back In Stock</h6>
                                    <p className="text-light thin">A Notification is Sent To Subscribers Whenever an Out-Of-Stock Product is made available again</p>
                                </div>
                            </div>                                            
                        </div>
                        <div className="col-6 col-sm">
                            <label className="thin text-light">Sent</label>
                            <h5 className="text-dark">{wooCommData?.back_in_stock?.sent || 0}</h5>
                        </div>
                        <div className="col-6 col-sm">
                            <label className="thin text-light">Impressions</label>
                            <h5 className="text-dark">{wooCommData?.back_in_stock?.delivered || 0}</h5>
                        </div>
                        <div className="col-6 col-sm">
                            <label className="thin text-light">Clicks</label>
                            <h5 className="text-dark">{wooCommData?.back_in_stock?.opened || 0}</h5>
                        </div>
                        <div className="col-6 col-sm">
                            <label className="thin text-light">Revenue</label>
                            <h5 className="text-dark"><Amount amount={wooCommData?.back_in_stock?.revenue || 0} /></h5>
                        </div>
                        <div className="col-sm toggle-block">
                            <label className="thin text-light d-none d-lg-block">Actions</label>
                            <label className="toggle-control toggle-control-xs">
                                <input type="checkbox" onChange={disableBackInStock.mutate}  checked={wooCommData?.back_in_stock?.is_active} />
                                <span className="control"></span>
                            </label>
                        </div>
                        <div className="col-12 col-sm align-self-center">
                            <button className="btn btn-primary" onClick={() => navigateTo('/woocommerce-back-in-stock')}>Setup</button>
                        </div>
                    </div>
                    <div className="row align-items-center automation-categories">
                        <div className="col-12 col-xl-5 br-right">
                            <div className="media">
                                <div className="media_figure media-rounded">
                                    <i className="icon icon-2x icon-money"></i>
                                </div>
                                <div className="media-body">
                                    <h6 className="text-dark medium">Price Drop</h6>
                                    <p className="text-light thin">A notification is sent to the subscriber whwnever the price of a product is dropped</p>
                                </div>
                            </div>                                            
                        </div>
                        <div className="col-6 col-sm">
                            <label className="thin text-light">Sent</label>
                            <h5 className="text-dark">{wooCommData?.price_drop?.sent || 0}</h5>
                        </div>
                        <div className="col-6 col-sm">
                            <label className="thin text-light">Impressions</label>
                            <h5 className="text-dark">{wooCommData?.price_drop?.delivered || 0}</h5>
                        </div>
                        <div className="col-6 col-sm">
                            <label className="thin text-light">Clicks</label>
                            <h5 className="text-dark">{wooCommData?.price_drop?.opened || 0}</h5>
                        </div>
                        <div className="col-6 col-sm">
                            <label className="thin text-light">Revenue</label>
                            <h5 className="text-dark"><Amount amount={wooCommData?.price_drop?.revenue || 0} /></h5>
                        </div>
                        <div className="col-sm toggle-block">
                            <label className="thin text-light d-none d-lg-block">Actions</label>
                            <label className="toggle-control toggle-control-xs">
                                <input type="checkbox" onChange={disablePriceDrop.mutate}  checked={wooCommData?.price_drop?.is_active} />
                                <span className="control"></span>
                            </label>
                        </div>
                        <div className="col-12 col-sm align-self-center">
                            <button className="btn btn-primary" onClick={() => navigateTo('/woocommerce-price-drop')}>Setup</button>
                        </div>
                    </div>
                    <div className="row align-items-center automation-categories">
                        <div className="col-12 col-xl-5 br-right">
                            <div className="media">
                                <div className="media_figure media-rounded">
                                    <i className="icon icon-2x icon-bug"></i>
                                </div>
                                <div className="media-body">
                                    <h6 className="text-dark medium">Shipping Notification</h6>
                                    <p className="text-light thin">A Notification is sent to the subscriber as soon as the status of their fulfilment is updated</p>
                                </div>
                            </div>                                            
                        </div>
                        <div className="col-6 col-sm">
                            <label className="thin text-light">Sent</label>
                            <h5 className="text-dark">{wooCommData?.shipping_alert?.sent || 0}</h5>
                        </div>
                        <div className="col-6 col-sm">
                            <label className="thin text-light">Impressions</label>
                            <h5 className="text-dark">{wooCommData?.shipping_alert?.delivered || 0}</h5>
                        </div>
                        <div className="col-6 col-sm">
                            <label className="thin text-light">Clicks</label>
                            <h5 className="text-dark">{wooCommData?.shipping_alert?.opened || 0}</h5>
                        </div>
                        <div className="col-6 col-sm">
                            {/* <label className="thin text-light">Revenue</label>
                            <h5 className="text-dark">$ {wooCommData?.shipping_alert?.revenue || 0}</h5> */}
                        </div>
                        <div className="col-sm toggle-block">
                            <label className="thin text-light d-none d-lg-block">Actions</label>
                            <label className="toggle-control toggle-control-xs">
                                <input type="checkbox" onChange={disableShippingNotification.mutate}  checked={wooCommData?.shipping_alert?.is_active} />
                                <span className="control"></span>
                            </label>
                        </div>
                        <div className="col-12 col-sm align-self-center">
                            <button className="btn btn-primary"  onClick={() => navigateTo('/woocommerce-shipping-notification')}>Setup</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>

}


export default WooCommerceAutomation;